import { render, staticRenderFns } from "./PropertyGallery.vue?vue&type=template&id=0c0e9255&scoped=true&"
import script from "./PropertyGallery.vue?vue&type=script&lang=js&"
export * from "./PropertyGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0e9255",
  null
  
)

export default component.exports